var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIcon1 = function SvgIcon1(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 49,
    viewBox: "0 0 63 49",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0678 48.3489H45.9043V23.3364C47.605 22.6851 50.3451 21.8725 53.7922 21.8429C57.438 21.8119 60.3247 22.6704 62.0678 23.3364V48.3489Z",
    fill: "#cdd2d7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8664 48.3489H25.752V14.1312C28.0812 13.2401 31.8287 12.1284 36.5445 12.088C41.5326 12.0454 45.4847 13.2199 47.8664 14.1312V48.3489Z",
    fill: "#8e939f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3563 48.3488H0.697266V4.00358C3.71591 2.84891 8.57245 1.40785 14.684 1.35572C21.1488 1.30033 26.2686 2.82252 29.3563 4.00358V48.3488Z",
    fill: "#1d2535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91147 48.4818H4.16797V0.371748C4.16797 0.166487 4.33446 0 4.53972 0C4.7453 0 4.91147 0.166487 4.91147 0.371748V48.4818Z",
    fill: "#cdd2d7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50328 48.4818H7.75977V0.371748C7.75977 0.166487 7.92627 0 8.13153 0C8.33712 0 8.50328 0.166487 8.50328 0.371748V48.4818Z",
    fill: "#cdd2d7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 3.96703H7.98698V3.42847H4.69531V3.96703Z",
    fill: "#cdd2d7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 7.32527H7.98698V6.78638H4.69531V7.32527Z",
    fill: "#cdd2d7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 10.6832H7.98698V10.1443H4.69531V10.6832Z",
    fill: "#cdd2d7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 14.0408H7.98698V13.5022H4.69531V14.0408Z",
    fill: "#cdd2d7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 17.3987H7.98698V16.8601H4.69531V17.3987Z",
    fill: "#cdd2d7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 20.7569H7.98698V20.218H4.69531V20.7569Z",
    fill: "#cdd2d7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 24.1147H7.98698V23.5762H4.69531V24.1147Z",
    fill: "#cdd2d7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 27.4724H7.98698V26.9338H4.69531V27.4724Z",
    fill: "#cdd2d7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 30.8306H7.98698V30.2917H4.69531V30.8306Z",
    fill: "#cdd2d7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 34.1885H7.98698V33.6499H4.69531V34.1885Z",
    fill: "#cdd2d7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 37.5464H7.98698V37.0078H4.69531V37.5464Z",
    fill: "#cdd2d7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 40.9044H7.98698V40.3655H4.69531V40.9044Z",
    fill: "#cdd2d7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 44.2622H7.98698V43.7236H4.69531V44.2622Z",
    fill: "#cdd2d7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69531 47.6201H7.98698V47.0815H4.69531V47.6201Z",
    fill: "#cdd2d7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1523 29.1562V31.8914H31.8202C32.3239 31.8914 32.7321 32.2997 32.7321 32.8031V48.3488H35.6449V32.1117C35.6449 30.4794 34.3221 29.1562 32.6885 29.1562H26.1523Z",
    fill: "#1d2535"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8301 35.0955V36.9842H49.7463C50.0917 36.9842 50.3751 37.266 50.3751 37.614V48.3488H52.3854V37.1363C52.3854 36.009 51.4731 35.0955 50.3458 35.0955H45.8301Z",
    fill: "#8e939f"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon1.a05add82.svg";
export { ForwardRef as ReactComponent };